import { render } from "./BannerComponent.vue?vue&type=template&id=410cddb5&scoped=true"
import script from "./BannerComponent.vue?vue&type=script&lang=js"
export * from "./BannerComponent.vue?vue&type=script&lang=js"

import "./BannerComponent.vue?vue&type=style&index=0&id=410cddb5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-410cddb5"]])

export default __exports__